module.exports = __webpack_public_path__ + "media/images/redesign-images/essentials/perfect/perfect-11-4f9b93278e2909a1dad614f401f3ae00.jpg";